import defaultAvatar from '../images/gd-default-avatar.png';
import { useImageFallbackSrc } from './useImageFallbackSrc';

export const useAvatarFallbackSrc = (src: unknown) => useImageFallbackSrc(src, defaultAvatar.src);
